import { Button } from "@tellescope/ui";
import { useTranslation } from "react-i18next";

export interface CollectorFooterProps {
  canSubmit: boolean;
  onCancel: () => void;
}

/** Shared Cancel / Insert footer for the token collectors. */
export const CollectorFooter = ({ canSubmit, onCancel }: CollectorFooterProps) => {
  const { t } = useTranslation("templates");
  return (
    <div className="flex justify-end gap-2 pt-2">
      <Button type="button" variant="outline" onClick={onCancel}>
        {t("Cancel")}
      </Button>
      <Button type="submit" disabled={!canSubmit}>
        {t("Insert")}
      </Button>
    </div>
  );
};
